import { render, staticRenderFns } from "./okpd2-selector.vue?vue&type=template&id=551c6baa&"
import script from "./okpd2-selector.vue?vue&type=script&lang=ts&"
export * from "./okpd2-selector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports